import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../../core/services/notification.service';
import { RegisterPersonCommandDto } from '../../../core/dto/register-person-command';
import { PeopleResourceService } from '../../../core/api/people-resource.service';
import { MetadataService } from '../../../core/services/metadata.service';

@Component({
    selector: 'isav-people-register-page',
    templateUrl: './people-register-page.html',
    styleUrls: ['./people-register-page.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleRegisterPage implements OnInit {
    loading = false;

    constructor(
        private router: Router,
        private notificationService: NotificationService,
        private peopleService: PeopleResourceService,
        private metaService: MetadataService
    ) {}

    ngOnInit() {
        this.metaService.setTitle('Sign Up');
    }

    onRegister(data: RegisterPersonCommandDto): void {
        // Temporary fix until field will be created to handle it.
        if (data.linksToCV === null) {
            data = { ...data, linksToCV: [] };
        }

        if (data.fieldOfInterests === null) {
            data = { ...data, fieldOfInterests: [] };
        }

        this.peopleService.register(data).subscribe((response) => {
            this.loading = false;
            this.notificationService.add({
                title: 'Success',
                message:
                    'You has been successfully registered. Administrator needs to confirm you account before you can log in. Look for your email box!',
                type: 'success',
                delay: 100000,
            });
            this.router.navigateByUrl('/');
        });
    }
}
